import { HttpContextToken } from '@angular/common/http';

// Context applied to HttpClient requests when interceptors should be skipped
// By default neither interceptor is skipped
export const SKIP_AUTH0_TOKEN = new HttpContextToken(() => false);
export const SKIP_HUMI_TOKEN = new HttpContextToken(() => false);
